<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Dashboard</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <p class="mb-8 leading-normal">Selamat Datang! Berikut adalah hasil summary dari data yang terdapat pada aplikasi.
      </p>
      <div class="row">
        <div class="col-sm-6 col-lg-3" v-for="(row, i) in dashboard" :key="`dashboard-${i}`">
          <div class="card total text-light" :style="`background-color: ${row.color}`">
            <div class="card-body">
              <Icon :icon="row.icon" />
              <h2 class="card-title fs-1" v-text="row.val"></h2>
              <p class="card-text fw-bold" v-text="row.label"></p>
              <!---->
            </div>
            <Link :href="row.link" class="card-footer d-flex justify-content-between cp text-white">
            <p class="m-0">Selengkapnya</p>
            <Icon :icon="['fa', 'arrow-alt-circle-right']" />
            </Link>
          </div>
        </div>
      </div>
      
      <div class="card">
        <div class="card-body">
          <div class="d-flex border-bottom pb-2 justify-content-between">
            <h4 @click="kabupaten_pilih = ''" >Data Per Wilayah</h4>
            <h4 @click="kabupaten_pilih = ''" class="btn-link cp" v-text="kabupaten_pilih"></h4>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th class="text-center">No</th>
                  <th>Kabupaten</th>
                  <th class="text-center">Unit Usaha</th>
                  <th class="text-center">IKM</th>
                  <th class="text-center">Tenaga Kerja</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in hybridWilayah()" :key="`perkabkec-${i}`">
                  <td class="text-center" v-text="i + 1"></td>
                  <td>
                    <span v-if="kabupaten_pilih" v-text="row.urai"></span>
                    <span v-else v-text="row.urai" @click="kabupaten_pilih = row.urai" class="btn-link cp"></span>
                  </td>
                  <td class="text-center" v-text="row.unit_usaha"></td>
                  <td class="text-center" v-text="row.ikm"></td>
                  <td class="text-center" v-text="row.tenaga_kerja"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="2" class="text-center">Jumlah</th>
                  <th class="text-center" v-text="hybridWilayah().reduce((store, row) => store + parseInt(row.unit_usaha), 0)"></th>
                  <th class="text-center" v-text="hybridWilayah().reduce((store, row) => store + parseInt(row.ikm), 0)"></th>
                  <th class="text-center" v-text="hybridWilayah().reduce((store, row) => store + parseInt(row.tenaga_kerja), 0)"></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layout from '@/layout/Index'
export default {
  props: {
    jumlah: Object,
    perkabupaten: Array,
    perkecamatan: Array,
    appmode: String
  },
  layout,
  data() {
    return {
      dashboard: [],
      kabupaten_pilih: ''
    }
  },
  methods: {
    hybridWilayah() {
      return this.kabupaten_pilih
      ? this.perkecamatan.filter(r => r.alamat_kabupaten == this.kabupaten_pilih)
      : this.perkabupaten
    }
  },
  mounted() {
    const dashboard = [
      {
        label: 'Total Data IKM',
        icon: ['fa', 'business-time'],
        color: '#109618',
        key: 'indag_direktori_ikm',
        link: '/admin/indagdirekikm',
        val: 0
      },
      {
        label: 'Total Data Sentra',
        icon: ['fa', 'section'],
        color: '#FF9900',
        key: 'indag_sentra_ikm',
        link: '/admin/indagsentra',
        val: 0
      },
      {
        label: 'Total Data Klasifikasi',
        icon: ['fa', 'history'],
        color: '#DC3912',
        key: 'indag_klasifikasi',
        link: '/admin/indagklasifikasi',
        val: 0
      },
      {
        label: 'Total Data Perusahaan',
        icon: ['fa', 'building'],
        color: '#990099',
        key: 'indag_proyek',
        link: '/admin/indagperusahaan',
        val: 0
      },
      {
        label: 'Total Data Export',
        icon: ['fa', 'truck-pickup'],
        color: '#3B3EAC',
        key: 'indag_export',
        link: '/admin/indagexport',
        val: 0
      },
      {
        label: 'Total Data Pegawai',
        icon: ['fa', 'user-tie'],
        color: '#22AA99',
        key: 'indag_pegawai',
        link: '/admin/indagpegawai',
        val: 0
      },
      {
        label: 'Total Pengguna',
        icon: ['fa', 'users'],
        color: '#316395',
        key: 'user',
        link: '/admin/users',
        val: 0
      }
    ];

    if(this.appmode == 'satudata') {
      dashboard.map(row => {
        row.val = this.jumlah[row.key];
      });
      this.dashboard = dashboard;
    }
  }
}
</script>
